function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.code1{fill-rule:evenodd;clip-rule:evenodd;fill:#FCC5A8;}\n\t.code2{fill-rule:evenodd;clip-rule:evenodd;fill:#0F1014;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_"
}, /*#__PURE__*/React.createElement("circle", {
  className: "code2",
  cx: 500,
  cy: 500,
  r: 500
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "code1",
  d: "M585.1,270.5c-42,42.7-61.6,98.8-94.1,152c-32.3,52.9-65.3,109.8-97.7,162.8c-18.2,29.8-27.7,65.6-50.7,90.5 c-0.2,16.3,0.3,27.6,7.2,36.2c6.1,8.7,14.3,11,21.7,18.1h21.7c35.8-36.4,51.8-81,79.6-126.6c37.4-61.2,74.7-126.8,112.2-188.2 c18.2-29.8,27.7-65.6,50.7-90.5c0.2-16.3-0.3-27.6-7.2-36.2C619.5,275.3,608.1,270.1,585.1,270.5z M190.7,509.3 c10.6-27.6,155.8-124.9,65.1-155.6c-5.5-3.8-14.8-3.8-25.3-3.6c-45.3,48.2-91.3,97.1-137.5,144.7 c1.5,57.6,102.1,132.5,137.5,166.4c25.6-0.1,32.2-5.7,47-14.5c2.5-10.5,11.4-21.8,7.2-36.2C278.8,589.8,209.8,521.4,190.7,509.3z  M899.9,480.3c-11-16.8-114.2-121.1-130.3-126.6c-5.5-3.8-14.8-3.8-25.3-3.6c-9.7,10.4-18.9,22.3-28.9,32.6 c1.7,41.2,66.5,101.7,94.1,119.4C799,531,765.2,544.5,748,567.2c-11.8,15.6-20.1,31.8-32.6,47c0.8,12.3,1.7,18.5,7.2,25.3 c5.1,13.9,12.5,13.1,21.7,21.7c53.8-0.6,133.1-109.3,162.8-144.7C906.8,500.6,906.4,490.2,899.9,480.3z"
}))));

var SvgCode = function SvgCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Code.c3785ce8.svg";
export { ForwardRef as ReactComponent };